export const state = {
  tableData: null,
}

export const mutations = {
  SET_TABLE_DATA(state, payload) {
    state.tableData = payload
  },
  ADD_NEW_STOCK(state, payload) {
    if (state.tableData.rows) {
      state.tableData.rows.push(payload)
    }
  },
  ADD_FIRST_DATA_TO_TABLE(state, payload) {
    state.tableData = payload
  },
  EDIT_STOCK(state, payload) {
    const selectedRow = state.tableData.rows.find(e => e.id === payload.id)
      ? state.tableData.rows.find(e => e.id === payload.id)
      : state.tableData.rows.find(e => e.mockId === payload.id)
    selectedRow.items.forEach(e => {
      if (e.fieldName === 'Count') {
        e.value = payload.payload.find(x => x.fieldName === 'Count').value
      }
      if (e.fieldName === 'Price') {
        e.value = payload.payload.find(x => x.fieldName === 'Price').value
      }
      if (e.fieldName === 'IsAvailable') {
        e.value = payload.payload.find(x => x.fieldName === 'IsAvailable').value
        e.color = payload.payload.find(x => x.fieldName === 'IsAvailable').color
      }
    })
  },
}

export const actions = {
  setTableData({ commit }, payload) {
    commit('SET_TABLE_DATA', payload)
  },
  addNewStock({ commit }, payload) {
    commit('ADD_NEW_STOCK', payload)
  },
  addFirstDataToTable({ commit }, payload) {
    commit('ADD_FIRST_DATA_TO_TABLE', payload)
  },
}
